import { API } from 'aws-amplify'
import { gql } from 'graphql-tag'
import { getToken } from 'user-auth'

const updateWorkspaceById = async (id, input) => {
  const token = await getToken()

  const { data, errors } = await API.graphql({
    query: UPDATE_WORKSPACE_BY_ID_MUTATION,
    variables: { id, input },
    authMode: 'AMAZON_COGNITO_USER_POOLS',
    authToken: token
  })
  if (errors) throw errors
  return data?.updateWorkspaceById
}

const UPDATE_WORKSPACE_BY_ID_MUTATION = gql`
  mutation UpdateWorkspaceById($id: ID!, $input: UpdateWorkspaceInput!) {
    updateWorkspaceById(id: $id, input: $input) {
      description
      name
      logo
      email
      twitterUsername
      websiteUrl
      communityUrl
    }
  }
`

export { updateWorkspaceById, UPDATE_WORKSPACE_BY_ID_MUTATION }
